Number.isNaN =
  Number.isNaN ||
  function(value) {
    // eslint-disable-next-line no-self-compare
    return value !== value;
  };
